import { AppBar, Toolbar, IconButton } from '@mui/material';
import { UserButton } from '@clerk/clerk-react';
import config from '../config';

function TopBar() {
  const takeMeHome = function () {
    window.location.href = config.SITE_URL;
    return null;
  };

  return (
    <AppBar position='static'>
      <Toolbar variant='dense' style={{ justifyContent: 'space-between' }}>
        <IconButton onClick={takeMeHome}>
          {/* TODO resize image to actually be smaller for load times */}
          {/* also this text needs to be bigger */}
          <img style={{ width: '100px' }} alt='image' src='app/logo.png' />
        </IconButton>
        <UserButton></UserButton>
      </Toolbar>
    </AppBar>
  );
}

export default TopBar;
